import { render, staticRenderFns } from "./DefaultSelect.vue?vue&type=template&id=2b8f2310&scoped=true"
import script from "./DefaultSelect.vue?vue&type=script&lang=js"
export * from "./DefaultSelect.vue?vue&type=script&lang=js"
import style0 from "./DefaultSelect.vue?vue&type=style&index=0&id=2b8f2310&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f2310",
  null
  
)

export default component.exports